import { styled } from "webapp/styled-components";

export const GroupHeader = styled.div`
    padding: ${p => p.theme.pageMarginMedium}px ${p => p.theme.pageMarginMedium}px
        ${p => p.theme.componentSmallInnerVerticalPadding}px ${p => p.theme.pageMarginMedium}px;

    ${p => p.theme.fontStyles.Subheader4};
    color: ${p => p.theme.fgColorDark};

    display: flex;
    justify-content: space-between;

    > * {
        flex-shrink: 0;
    }

    > *:first-child {
        flex-shrink: 1;
    }
`;
